import React, { useContext, useEffect, useState } from "react";
import ProfileData from "./MiniComponents/ProfileData/ProfileData";
import UpdateUser from "../../Update/UpdateUser/UpdateUser";
import { AuthContext } from "../../../context/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { getAllContracts } from "../../../redux/contractSlice/contractSlice";
import { getAllMaintenanceSchedule } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";

export default function Profile() {
  const { user } = useContext(AuthContext);
  const [currentUser, setCurrentUser] = useState({
    id: "",
    name: "",
    email: "",
    phone: "",
    profile_image: "",
  });
  const dispatch = useDispatch();
  const { allContracts } = useSelector((state) => state.contract);
  const { maintenanceSchedules } = useSelector((state) => state.maintenanceSchedule);
  useEffect(() => {
    dispatch(getAllContracts());
    dispatch(getAllMaintenanceSchedule());
  }, [dispatch]);
  useEffect(() => {
    if (user) {
      setCurrentUser(user);
    }
  }, [user]);
  return (
    <>
      <div className="main">
        <section className="companyProfile">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 ps-0 mb-5 position-relative">
                <ProfileData currentUser={currentUser} maintenanceSchedules={maintenanceSchedules} allContracts={allContracts} />
              </div>
              <UpdateUser currentUser={currentUser} setCurrentUser={setCurrentUser} />
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
